import { render, staticRenderFns } from "./SearchFeature.vue?vue&type=template&id=50986e28"
import script from "./SearchFeature.vue?vue&type=script&lang=js"
export * from "./SearchFeature.vue?vue&type=script&lang=js"
import style0 from "./SearchFeature.vue?vue&type=style&index=0&id=50986e28&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports